import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'msc-showroom-exhibit-aside-page',
    templateUrl: './showroom-exhibit-aside-page.component.html',
    styleUrls: ['./showroom-exhibit-aside-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ShowroomExhibitAsidePageComponent {

}
